<template>
  <div
    class="fixed z-50 flex min-h-screen w-screen items-center justify-center overflow-hidden bg-kekkle-yellow text-center dark:bg-kekkle-dark"
  >
    <div class="flex flex-col items-center gap-4">
      <img
        alt="Kekkle Logo"
        class="mb-4 w-24 animate-bounce"
        :src="logoAltTrans"
      />
      <p class="text-lg font-medium text-kekkle-dark dark:text-white">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup>
import logoAltTrans from "@/assets/images/logo/logo-color-alt-trans.svg";

defineProps({
  message: {
    type: String,
    default: "henkk",
  },
});
</script>
